<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'input',
          label: 'CRMZ Business Id',
          key: 'crmzBusinessId',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
          defaultValue: this.$route.query.businessId,
        },
      ],
    }
  },
  methods: {
    async validate() {
      const result = await this.$refs.form.validateForm()
      result.financialStatementType = '1'
      result.period = '1'
      Object.keys(result).forEach(key => {
        const value = result[key]
        if (typeof value === 'boolean') {
          value ? (result[key] = 1) : (result[key] = 0)
        }
      })
      return result
    },
  },
  components: {
    MForm,
  },
}
</script>
